import * as React from "react";
import { Spinner } from "@shared/common";

export const LoadingComponent = () => {
  return (
    <div className="d-inline-block m-0">
      <Spinner loading={true} />
    </div>
  );
};
